import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { selectLoading, selectOwnershipAndGroup } from '../../store/slice'
import { Chart } from './Chart'
import classes from './index.module.scss'
import { InfoList } from './InfoList'

export const OwnershipAndGroup = () => {
  const data = useSelector(selectOwnershipAndGroup())
  const isLoading = useSelector(selectLoading('ownershipAndGroup'))

  const renderContent = () => {
    return (
      <>
        <InfoList />
        <Element
          className={classes.divider}
          style={{ backgroundColor: '#D5D5D5' }}
        />
        <Chart />
      </>
    )
  }

  return (
    <Element className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : !data || !Object.keys(data).length ? (
        <Notification />
      ) : (
        renderContent()
      )}
    </Element>
  )
}
